import { DollarSign, TrendingUp, TrendingDown, AlertTriangle, Users, PieChart } from "lucide-react";
import { Card } from "@/components/ui/card";
import { LenderStats } from "@/types/lender";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";

interface DashboardMetricsProps {
  stats: {
    totalLoans: number;
    activeLoans: number;
    totalAmount: number;
    averageRiskScore: number;
  };
}

export const DashboardMetrics = ({ stats }: DashboardMetricsProps) => {
  return (
    <div className="grid md:grid-cols-4 gap-6">
      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">Total Portfolio</p>
            <p className="text-2xl font-bold">${stats.totalAmount.toLocaleString()}</p>
          </div>
          <DollarSign className="h-8 w-8 text-primary" />
        </div>
        <div className="mt-4 flex items-center text-sm">
          <TrendingUp className="h-4 w-4 text-green-500 mr-1" />
          <span className="text-green-500">+12.5%</span>
          <span className="text-muted-foreground ml-2">from last month</span>
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">Active Loans</p>
            <p className="text-2xl font-bold">{stats.activeLoans}</p>
          </div>
          <PieChart className="h-8 w-8 text-primary" />
        </div>
        <div className="mt-4 flex items-center text-sm">
          <TrendingUp className="h-4 w-4 text-green-500 mr-1" />
          <span className="text-green-500">+5.2%</span>
          <span className="text-muted-foreground ml-2">from last month</span>
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">Risk Score</p>
            <p className="text-2xl font-bold">{stats.averageRiskScore.toFixed(1)}</p>
          </div>
          <AlertTriangle className="h-8 w-8 text-yellow-500" />
        </div>
        <div className="mt-4 flex items-center text-sm">
          <TrendingDown className="h-4 w-4 text-red-500 mr-1" />
          <span className="text-red-500">-2.1%</span>
          <span className="text-muted-foreground ml-2">risk exposure</span>
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">Active Borrowers</p>
            <p className="text-2xl font-bold">{stats.totalLoans}</p>
          </div>
          <Users className="h-8 w-8 text-primary" />
        </div>
        <div className="mt-4 flex items-center text-sm">
          <TrendingUp className="h-4 w-4 text-green-500 mr-1" />
          <span className="text-green-500">+8.3%</span>
          <span className="text-muted-foreground ml-2">new borrowers</span>
        </div>
      </Card>
    </div>
  );
};